<template>
  <div style="height: 100%;">

    <div style="height: 8%; padding: 10px 10px 0px 10px; display: flex; align-items: center;">
      <v-text-field 
        ref="productSearchQuery"
        v-model="input.productSearchQuery"
        @input="selectProductFromProductSearchComponentInterval()"
        :loading="loader.selectProductFromProductSearchComponent"
        :append-inner-icon="input.productSearchQuery && /\S/.test(input.productSearchQuery) ? 'mdi-magnify-remove-outline' : 'mdi-magnify'"
        @click:append-inner.stop="$generalFunctions.default.blurInput(this, 'productSearchQuery'); input.productSearchQuery = null; selectProductFromProductSearchComponentInterval();"
        @keydown.enter.prevent="selectProductFromProductSearchComponent()" 
        placeholder="Buscar productos" 
        variant="solo-filled" 
        density="compact"
        hide-details
        autocomplete="off"
      ></v-text-field>
    </div>
    
    <div style="height: 92%; padding: 10px 10px; overflow-y: auto; scrollbar-width: none; -ms-overflow-style: none;">
      <div v-if="display.products.length == 0" style="height: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center;">
        <v-icon size="large">mdi-magnify</v-icon>
        <p style="font-size: 0.8rem; color: #999; text-align: center; margin-top: 10px; cursor: default; user-select: none;">{{ input.productSearchQuery && /\S/.test(input.productSearchQuery) && input.productSearchQuery.length >= 5 ? (interval.productSearchQueryInterval != null ? 'Buscando...' : 'No se encontraron productos') : 'Escriba el código o nombre del producto a buscar' }}</p>
      </div>
      <div v-else>
        <div v-for="product in display.products" v-bind:key="product">
          <v-card elevation="0" style="margin-bottom: 10px;" :color="productCardColor">
            <div style="display: flex;">
              <div style="width: 25%; display: flex; align-items: center; justify-content: center;">
                <img 
                  v-if="product.productFile"
                  @click="$root.dialogComponent.openMediaDialog(product.productFile, product.productName, 'webp');"
                  :src="product.productFile"
                  draggable="false"
                  style="max-width: 100%; height: auto; object-fit: contain; cursor: pointer;"
                  alt="Sin imagen"
                >
                <div v-else style="width: 100%; height: 100px; background-color: #f5f5f5; display: flex; align-items: center; justify-content: center;">
                  <span style="color: #999;">Sin imagen</span>
                </div>
              </div>
              <div style="width: 75%; padding: 10px;">
                <div style="display: flex; align-items: center; gap: 5px;">
                  <p style="font-size: 0.9rem;"><strong>{{ product.productChilds.length > 0 && product.selectedProductChild ? product.productChilds.find(productChild => productChild.productID == product.selectedProductChild).productName : product.productName }}</strong></p>
                  <div style="margin-left: auto; display: flex; align-items: center; gap: 5px;">
                    <v-tooltip v-if="showUpdateStockButton" :disabled="systemInformationData.tooltipDisabled" text="Consultar stock actualizado" location="top">
                      <template v-slot:activator="{ props }">
                        <v-icon v-bind="props" @click="selectProductStockFromProductStockSearchComponent(product)" size="small" color="primary" class="hoverableElement">mdi-update</v-icon>
                      </template>
                    </v-tooltip>
                    <v-tooltip v-if="showAddToCartButton && product.selectedProductChild" :disabled="systemInformationData.tooltipDisabled" text="Agregar al carrito" location="top">
                      <template v-slot:activator="{ props }">
                        <v-icon v-bind="props" @click="addToCart(product.selectedProductChild, product.productChilds.length > 0 ? product.productChilds.find(productChild => productChild.productID == product.selectedProductChild).productName : product.productName, product.productPrice)" size="small" color="primary" class="hoverableElement">mdi-cart</v-icon>
                      </template>
                    </v-tooltip>
                    <v-tooltip v-if="showAddToFollowupButton && product.selectedProductChild" :disabled="systemInformationData.tooltipDisabled" text="Agregar al seguimiento" location="top">
                      <template v-slot:activator="{ props }">
                        <v-icon v-bind="props" @click="addToFollowup(product.selectedProductChild, product.productChilds.length > 0 ? product.productChilds.find(productChild => productChild.productID == product.selectedProductChild).productName : product.productName, product.productFile)" size="small" color="primary" class="hoverableElement">mdi-source-branch-plus</v-icon>
                      </template>
                    </v-tooltip>
                    <v-tooltip v-if="showSendToContactButton && product.selectedProductChild" :disabled="systemInformationData.tooltipDisabled" text="Enviar al contacto" location="top">
                      <template v-slot:activator="{ props }">
                        <v-icon v-bind="props" @click="sendToContact(product)" size="small" color="primary" class="hoverableElement">mdi-send</v-icon>
                      </template>
                    </v-tooltip>
                  </div>
                </div>
                <p style="font-size: 0.8rem; color: primary;">₡{{ $displayFunctions.default.parseAmountToDisplay(product.productPrice) }}</p>
                <p style="font-size: 0.7rem; color: #999; margin-top: 10px;">{{ product.productDescription }}</p>
                
                <div v-if="product.productChilds.length > 0">
                  <div style="display: flex; align-items: center; gap: 5px; margin-top: 10px; overflow-x: auto; scrollbar-width: none; -ms-overflow-style: none; overflow-y: hidden;">
                    <div v-for="productChild in product.productChilds" v-bind:key="productChild">
                      <v-chip 
                        @click="product.selectedProductChild == productChild.productID ? product.selectedProductChild = null : product.selectedProductChild = productChild.productID" 
                        :color="product.selectedProductChild == productChild.productID ? 'info' : 'primary'"
                        label
                        size="small"
                        density="compact"
                        variant="flat" 
                        class="hoverableText" 
                        elevation="2" 
                        style="margin-bottom: 3px;"
                      >
                        <p style="font-size: x-small;"><strong>{{ productChild.productNicotineLevel }}</strong></p>
                      </v-chip>
                    </div>
                  </div>
                  <div v-if="product.selectedProductChild" style="display: flex; align-items: center; gap: 5px; margin-top: 10px; overflow-x: auto; scrollbar-width: none; -ms-overflow-style: none; overflow-y: hidden;">
                    <div v-for="productStockByLocality in product.productChilds.find(productChild => productChild.productID == product.selectedProductChild).productStockByLocality" v-bind:key="productStockByLocality">
                      <v-tooltip :text="productStockByLocality.localityName" location="top">
                        <template v-slot:activator="{ props }">
                          <v-chip v-bind="props" 
                            :color="productStockByLocality.localityColor"
                            label
                            size="small"
                            density="compact"
                            variant="flat"
                            class="hoverableText"
                            elevation="2"
                            style="margin-bottom: 3px;"
                          >
                            <p style="font-size: x-small;"><strong>{{ productStockByLocality.productStockAmount }}</strong></p>
                          </v-chip>
                        </template>
                      </v-tooltip>
                    </div>
                  </div>
                </div>
                
                
                <div v-else style="display: flex; align-items: center; gap: 5px; margin-top: 10px; overflow-x: auto; scrollbar-width: none; -ms-overflow-style: none; overflow-y: hidden;">
                  <div v-for="productStockByLocality in product.productStockByLocality" v-bind:key="productStockByLocality">
                    <v-tooltip :text="productStockByLocality.localityName" location="top">
                      <template v-slot:activator="{ props }">
                        <v-chip v-bind="props" 
                          :color="productStockByLocality.localityColor"
                          label
                          size="small"
                          density="compact"
                          variant="flat"
                          class="hoverableText"
                          elevation="2"
                          style="margin-bottom: 3px;"
                        >
                          <p style="font-size: x-small;"><strong>{{ productStockByLocality.productStockAmount }}</strong></p>
                        </v-chip>
                      </template>
                    </v-tooltip>
                  </div>
                </div>
              </div>
            </div>
          </v-card>
        </div>
      </div>

    </div>
  </div>
</template>
  
<style scoped>

</style>

<script>
  import { systemInformation } from '@/utilities/systemInformation';

  export default {
    inject: ['$generalFunctions', '$displayFunctions', '$assets'],
    components: { },
    
    props: 
    {
      showUpdateStockButton: {
        type: Boolean,
        default: false
      },
      showAddToCartButton: {
        type: Boolean,
        default: false
      },
      showAddToFollowupButton: {
        type: Boolean,
        default: false
      },
      showSendToContactButton: {
        type: Boolean,
        default: false
      },
      productSearchQuery: {
        type: String,
        default: null
      },
      products: {
        type: Array,
        default: () => []
      },
      productCardColor: {
        type: String,
        default: 'surface'
      }
    },
    
    data: () => ({
      input: 
      {
        productSearchQuery: null
      },

      display: 
      {
        products: [],
        locality: []
      },

      navigation: 
      {
      },

      loader:
      {
        selectProductFromProductSearchComponent: false
      },

      interval:
      {
        productSearchQueryInterval: null
      },

      animation: {},
      
      systemInformationData: 
      {
        tooltipDisabled: false,
        updateSubscription: null
      }
    }),
  

    methods: {

      async selectProductFromProductSearchComponent(){
        this.loader.selectProductFromProductSearchComponent = true;
        const selectProductFromProductSearchComponentRequestQuery = 
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          },
          'productSearchQuery': this.input.productSearchQuery
        };
        const selectProductFromProductSearchComponentResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/SouqBillingConnection/functions/selectProductFromProductSearchComponent', selectProductFromProductSearchComponentRequestQuery);
        if (selectProductFromProductSearchComponentResult.success){
          this.display.products = selectProductFromProductSearchComponentResult.result.product.map(product => ({
            'productMainProductID': product.mi,
            'productID': product.i,
            'productName': product.n,
            'productDescription': product.d,
            'productPrice': product.p,
            'productFile': product.fi,
            'selectedProductChild': product.c.length > 0 ? null : product.i,
            'productChilds': product.c.length > 0 ? product.c.map(child => ({
              'productID': child.i,
              'productName': child.n,
              'productNicotineLevel': child.nl,
              'productStockByLocality': child.s.length > 0 ? child.s.map(productStockByLocality => ({
                'localityID': productStockByLocality.i,
                'localityName': selectProductFromProductSearchComponentResult.result.locality.find(locality => locality.i == productStockByLocality.i).n,
                'localityColor': selectProductFromProductSearchComponentResult.result.locality.find(locality => locality.i == productStockByLocality.i).c,
                'productStockAmount': productStockByLocality.s
              })) : []
            })) : [],
            'productStockByLocality': product.s.length > 0 ? product.s.map(productStockByLocality => ({
              'localityID': productStockByLocality.i,
              'localityName': selectProductFromProductSearchComponentResult.result.locality.find(locality => locality.i == productStockByLocality.i).n,
              'localityColor': selectProductFromProductSearchComponentResult.result.locality.find(locality => locality.i == productStockByLocality.i).c,
              'productStockAmount': productStockByLocality.s
            })) : []
          }));
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog(selectProductFromProductSearchComponentResult.result, 'error', 'Ha ocurrido un error inesperado al buscar los productos, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          }
        this.loader.selectProductFromProductSearchComponent = false;
        this.$emit('productsUpdate', this.display.products);
      },

      async selectProductStockFromProductStockSearchComponent(product){
        const selectProductStockFromProductStockSearchComponentRequestQuery = 
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          },
          'productMainProductIDOrProductID': product.productMainProductID || product.productID
        };
        const selectProductStockFromProductStockSearchComponentResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/SouqBillingConnection/functions/selectProductStockFromProductStockSearchComponent', selectProductStockFromProductStockSearchComponentRequestQuery);
        if (selectProductStockFromProductStockSearchComponentResult.success){
          if (product.productMainProductID){
            product.productChilds.forEach(productChild => {
              productChild.productStockByLocality.forEach(productStockByLocality => {
                productStockByLocality.productStockAmount = selectProductStockFromProductStockSearchComponentResult.result[0].c.find(child => child.i == productChild.productID).s.find(currentProductStockByLocality => currentProductStockByLocality.i == productStockByLocality.localityID).s;
              });
            });
          } else {
            product.productStockByLocality.forEach(productStockByLocality => {
              productStockByLocality.productStockAmount = selectProductStockFromProductStockSearchComponentResult.result[0].s.find(currentProductStockByLocality => currentProductStockByLocality.i == productStockByLocality.localityID).s;
            });
          }
          this.$root.notificationDialog.showSystemNotificationDialog('selectProductStockFromProductStockSearchComponent_success', 'success', 'El stock del producto se ha actualizado correctamente', null, false);
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog(selectProductStockFromProductStockSearchComponentResult.result, 'error', 'Ha ocurrido un error inesperado al buscar el stock del producto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
      },

      selectProductFromProductSearchComponentInterval(){
        if (this.input.productSearchQuery != null && /\S/.test(this.input.productSearchQuery) && this.input.productSearchQuery.length >= 5){
          if (this.interval.productSearchQueryInterval) clearTimeout(this.interval.productSearchQueryInterval);
          this.interval.productSearchQueryInterval = setTimeout(() => {
            clearTimeout(this.interval.productSearchQueryInterval);
            this.selectProductFromProductSearchComponent();
          }, 1000);
        } else {
          if (this.interval.productSearchQueryInterval) clearTimeout(this.interval.productSearchQueryInterval);
          this.display.products.length = 0;
        }
        this.$emit('productSearchQueryUpdate', this.input.productSearchQuery);
        this.$emit('productsUpdate', this.display.products);
      },

      addToCart(productID, productName, productPrice){
        const addToCartEvent = 
        {
          'CRMWhatsappInvoiceProductProductID': productID,
          'CRMWhatsappInvoiceProductName': productName,
          'CRMWhatsappInvoiceProductPrice': productPrice,
          'CRMWhatsappInvoiceProductAmount': 1,
          'CRMWhatsappInvoiceProductDiscountMargin': 0
        };
        this.$emit('addToCart', addToCartEvent);
      },

      sendToContact(product){
        this.$emit('sendToContact', product);
      },

      addToFollowup(productID, productName, productImage){
        const addToFollowupEvent = 
        {
          'CRMWhatsappContactFollowupProductProductID': productID,
          'CRMWhatsappContactFollowupProductName': productName,
          'CRMWhatsappContactFollowupProductAmount': 1,
          'CRMWhatsappContactFollowupProductImage': productImage
        };
        this.$emit('addToFollowup', addToFollowupEvent);
      },

      focusInput(){
        this.$generalFunctions.default.focusInput(this, 'productSearchQuery');
      },

      async getSystemInformation(){
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
              this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
            });
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('ProductSearchComponent_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('ProductSearchComponent_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
      },
    },
    
    async mounted(){
      await this.getSystemInformation();      
      this.input.productSearchQuery = this.productSearchQuery;
      this.display.products = this.products;
    },
    
    
    beforeUnmount(){
      if (this.interval.productSearchQueryInterval) clearTimeout(this.interval.productSearchQueryInterval);
    }
  }
</script>